import React from 'react';
export function Footer() {
  return <footer className="w-full bg-cream py-12" data-id="element-22" data-mp="32wd2qgad7ltj">
      <div className="mx-auto flex max-w-6xl flex-col items-start gap-6 px-6 sm:flex-row sm:items-center sm:justify-between lg:px-8" data-id="element-23" data-mp="3gezf99jl213s">
        <div data-id="element-24" data-mp="32p5m4f11ouo9">
          <p className="font-serif text-lg text-ink" data-id="element-25" data-mp="32pp6s3i2xx5z">
            Desde el miedo hacia la libertad
          </p>
          <p className="mt-1 font-sans text-sm text-ink-light" data-id="element-26" data-mp="36nd6djupwe47">
            Psicología y espiritualidad para el día a día.
          </p>
        </div>

        <div className="font-sans text-sm text-ink-light" data-id="element-27" data-mp="38zaivynj750">
          <a href="mailto:hola@delmiedoalalibertad.com" className="transition-colors hover:text-gold-deep" data-id="element-28" data-mp="36d2kv7umpm9">
            hola@delmiedoalalibertad.com
          </a>
          <p className="mt-1" data-id="element-29" data-mp="3qf9rorxsn4hw">
            © {new Date().getFullYear()} · Todos los derechos reservados
          </p>
        </div>
      </div>
    </footer>;
}